import axiosHelper from './axios-helper';

const user = {
  register(data) {
    const url = '/api/register';
    return axiosHelper.POST(url, {
      data,
      headersObj: {'content-type': "application/json; charset=utf-8"}
    });
  },
  login(data) {
    const url = '/api/login';
    return axiosHelper.POST(url, {
      data,
      headersObj: {'content-type': "application/json; charset=utf-8"}
    });
  },
  checkAuth() {
    const url = '/api/check_auth';
    return axiosHelper.GET(url);
  },
  bindAmo(data) {
    const url = '/api/amo/add';
    return axiosHelper.POST(url, {data})
  },
  bindBitrix(data) {
    const url = '/api/bitrix/add';
    return axiosHelper.POST(url, {data})
  },
  getAmoList (workspace_id) {
    const url = '/api/amo/list?workspace_id='+ (workspace_id || null);
    return axiosHelper.GET(url);
  },
  getBitrixList (workspace_id) {
    const url = '/api/bitrix/list?workspace_id='+ (workspace_id || null);
    return axiosHelper.GET(url);
  },
  disableAmo (data) {
    const url = '/api/amo/disable';
    return axiosHelper.POST(url, {data});
  },
  disableBitrix (data) {
    const url = '/api/bitrix/disable';
    return axiosHelper.POST(url, {data});
  },
  enableAmo (data) {
    const url = '/api/amo/able';
    return axiosHelper.POST(url, {data});
  },
  enableBitrix (data) {
    const url = '/api/bitrix/able';
    return axiosHelper.POST(url, {data});
  },
  deleteAmo (data) {
    const url = '/api/amo/delete';
    return axiosHelper.POST(url, {data});
  },
  deleteBitrix (data) {
    const url = '/api/bitrix/delete';
    return axiosHelper.POST(url, {data});
  },
  getAmo(id) {
    const url = '/api/amo/get?id='+id;
    return axiosHelper.GET(url)
  },
  getBitrix(id) {
    const url = '/api/bitrix/get?id='+id;
    return axiosHelper.GET(url)
  },
  updateAmo (data) {
    const url = '/api/amo/update';
    return axiosHelper.POST(url, {data});
  },
  updateBitrix (data) {
    const url = '/api/bitrix/update';
    return axiosHelper.POST(url, {data});
  },

  //Отделы
  getDepartment(id) {
    const url = '/api/department/get?id='+id;
    return axiosHelper.GET(url)
  },
  bindDepartment(data) {
    const url = '/api/department/add';
    return axiosHelper.POST(url, {data})
  },
  getDepartmentList (workspace_id) {
    const url = '/api/department/list?workspace_id='+ (workspace_id || null);
    return axiosHelper.GET(url);
  },
  deleteDepartment (data) {
    const url = '/api/department/delete';
    return axiosHelper.POST(url, {data});
  },
  updateDepartment (data) {
    const url = '/api/department/update';
    return axiosHelper.POST(url, {data});
  },

  //Локации
  getLocation(id) {
    const url = '/api/location/get?id='+id;
    return axiosHelper.GET(url)
  },
  bindLocation(data) {
    const url = '/api/location/add';
    return axiosHelper.POST(url, {data})
  },
  getLocationList (workspace_id) {
    const url = '/api/location/list?workspace_id='+ (workspace_id || null);
    return axiosHelper.GET(url);
  },
  deleteLocation (data) {
    const url = '/api/location/delete';
    return axiosHelper.POST(url, {data});
  },
  updateLocation (data) {
    const url = '/api/location/update';
    return axiosHelper.POST(url, {data});
  },

  //Спецы - Specialist
  getSpecialist(id) {
    const url = '/api/specialist/get?id='+id;
    return axiosHelper.GET(url)
  },
  bindSpecialist(data) {
    const url = '/api/specialist/add';
    return axiosHelper.POST(url, {data})
  },
  getSpecialistList (workspace_id) {
    const url = '/api/specialist/list?workspace_id='+ (workspace_id || null);
    return axiosHelper.GET(url);
  },
  disableSpecialist (data) {
    const url = '/api/specialist/disable';
    return axiosHelper.POST(url, {data});
  },
  enableSpecialist (data) {
    const url = '/api/specialist/able';
    return axiosHelper.POST(url, {data});
  },
  deleteSpecialist (data) {
    const url = '/api/specialist/delete';
    return axiosHelper.POST(url, {data});
  },
  updateSpecialist (data) {
    const url = '/api/specialist/update';
    return axiosHelper.POST(url, {data});
  },

  //Workspace
  addWorkspace(data) {
    const url = '/api/workspace/add';
    return axiosHelper.POST(url, {data})
  },
  getWorkspaceList() {
    const url = '/api/workspace/list';
    return axiosHelper.GET(url)
  },
  deleteWorkspace (data) {
    const url = '/api/workspace/delete';
    return axiosHelper.POST(url, {data});
  },
  updateWorkspace (data) {
    const url = '/api/workspace/update';
    return axiosHelper.POST(url, {data});
  },

};

const projects = {
  getList (workspace_id) {
    const url = '/api/project/list?workspace_id='+ (workspace_id || null);
    return axiosHelper.GET(url);
  },
  addProject (data) {
    const url = '/api/project/add';
    return axiosHelper.POST(url, {data})
  },
  renameProject (data) {
    const url = '/api/project/rename';
    return axiosHelper.POST(url, {data})
  },
  getProject (data) {
    const url = '/api/project/get?project_id=' + data;
    return axiosHelper.GET(url)
  },
  getProjectItems (data) {
    const url = '/api/project/get_items?bg_id=' + data;
    return axiosHelper.GET(url)
  },
  getTypes () {
    const url = '/api/project_types/list';
    return axiosHelper.GET(url)
  },
  setType (data) {
    const url = 'api/project/set_type';
    return axiosHelper.POST(url, {data})
  },
  copyProject (data) {
    const url = 'api/project/copy?id=' + data;
    return axiosHelper.GET(url);
  },
  deleteProject (data) {
    const url = 'api/project/delete?id=' + data;
    return axiosHelper.GET(url);
  },
  saveBackground (data) {
    const url = '/api/project/add_bg';
    return axiosHelper.POST(url, data)
  },
  
  deleteItem (data) {
    const url = '/api/project/delete_item';
    return axiosHelper.POST(url, {data})
  },
  deleteGift (data) {
    const url = '/api/gift/delete';
    return axiosHelper.POST(url, {data})
  },
  deletePrice (data) {
    const url = '/api/price/delete';
    return axiosHelper.POST(url, {data})
  },
  deleteSubscribe (data) {
    const url = '/api/subscribe/delete';
    return axiosHelper.POST(url, {data})
  },

  saveButton (data) {
    const url = '/api/button/add';
    return axiosHelper.POST(url, {data})
  },
  saveText (data) {
    const url = '/api/text/add';
    return axiosHelper.POST(url, {data})
  },
  saveVideo (data) {
    const url = '/api/video/add';
    return axiosHelper.POST(url, {data})
  },
  saveImage (data) {
    const url = '/api/image/add';
    return axiosHelper.POST(url, {data})
  },
  saveGift (data, id) {
    let url;
    if (id){
      data.id = id;
      url = '/api/gift/update';
    }else
      url = '/api/gift/add';
    
    return axiosHelper.POST(url, {data})
  },
  savePrice (data, id) {
    let url;
    if (id){
      data.id = id;
      url = '/api/price/update';
    }
    else
      url = '/api/price/add';
    
    return axiosHelper.POST(url, {data})
  },
  saveSubscribe (data, id) {
    let url;
    if (id){
      data.id = id;
      url = '/api/subscribe/update';
    }
    else
      url = '/api/subscribe/add';
    
    return axiosHelper.POST(url, {data})
  },
  uploadImage (data) {
    const url = '/api/image/upload';
    return axiosHelper.POST(url, data)
  },
};

const API = {
  user,
  projects
};

export default API;
